import React from "react";
import cn from "classnames";

import { StyledTooltip, Wrapper } from "./styles";
import { IProps } from "./interfaces";

const Tooltip = ({ children, label, disabled, marginTop, light, dark, alwaysDisplay, grey, hideOnMobile, flipped }: IProps) => (
    <Wrapper hideOnMobile={!!hideOnMobile}>
        {children}
        <StyledTooltip
            className={cn(
                disabled && "Disabled",
                light && "Light",
                grey && "Grey",
                dark && "Dark",
                alwaysDisplay && "AlwaysDisplay",
                flipped && "Flipped"
            )}
            style={{ marginTop }}
        >
            {label}
        </StyledTooltip>
    </Wrapper>
);

export default Tooltip;
